import { createActionTypes } from 'utils/action/actionTypes';

export const GET_SMC_PAYMENT_GATEWAY = createActionTypes('GET_SMC_PAYMENT_GATEWAY');
